/* Berlin LWB Theme JS */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-drawer-open]');
    const closeBtn = e.target.closest('[data-drawer-close]');
    const drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;

    if (openBtn) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    if (closeBtn || e.target === drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Mobile sub-menu toggle ---------- */
  document.querySelectorAll('[data-mobile-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const sub = btn.nextElementSibling;
      if (sub) sub.style.display = (sub.style.display === 'block') ? 'none' : 'block';
    });
  });

  /* ---------- Collection slider arrows ---------- */
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-slider-track]');
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if (!track) return;
    const step = function () { return track.clientWidth * 0.8; };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(),  behavior: 'smooth' }); });
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.dataset.full || thumb.src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Ajax add to cart ---------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    if (!id) return;
    const original = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      const count = document.querySelector('[data-cart-count]');
      if (count) count.textContent = cart.item_count;
      btn.textContent = '✓ Hinzugefügt';
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
    })
    .catch(function () {
      btn.textContent = original;
      btn.disabled = false;
    });
  });
})();
